img {
  width: 78px;
  min-width: 78px;

  @include media-min(md) {
    width: 113px;
    min-width: 113px;
  }
}

a {
  text-decoration: none;

  &:focus {
    outline: 2px solid $color-turquoise-03;
  }
}
